module.exports = __webpack_public_path__ + "static/toodledo_3-01fa9722d29bd315cdf0a8da8cb7ce5f.png";